import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { Pagination } from '../shared';
import { CPCommerceAttribChildLinkModel } from '../../../../../models/aggregates/cp-commerce/cpcommerce-attrib-child-link.model';

@Injectable({
  providedIn: 'root'
})
export class CpCommerceAttributeChildLinkService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attribute-child-links' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attribute-child-links' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attribute-child-links' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getChildLinkByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.CPCOMMERCE_PREFIX}attribute-child-links`;
    }
    const UrlByCriteria = this.apiUrl + '/attributes/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<CPCommerceAttribChildLinkModel>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  postChildLink(
    dtoObject: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attribute-child-links' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    const url = this.apiUrl ;
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  postChildLinkPromise(
    dtoObject: any,
    visa: ApiVisa
  ): Promise<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CPCOMMERCE_PREFIX + 'attribute-child-links' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    const url = this.apiUrl ;
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    ).toPromise();
  }
}
